import React from 'react'
import withSlideUpModal from '../../utils/hoc/withSlideUpModalComponent'
import { SocialAccountData } from '../../types/influencer/influencerTypes'
import InstagramLogo from '../../assets/icons/instagram-logo.svg'
import YoutubeLogo from '../../assets/icons/youtube-logo.svg'
import Avatar from 'react-avatar'
const CampaignAccountSelectorModal: React.FC<{ onAccountSelection: (account: SocialAccountData) => void, socialAccounts: SocialAccountData[] }> = ({ onAccountSelection, socialAccounts }) => {
    const [selectedSocialAccount, setSelectedSocialAccount] = React.useState<SocialAccountData | null>(null);
    return (
        <div className='campaign-apply-confirmation mt-2'>
            <div className="px-3 campaign-apply-ig-connect-benefit-actions">
                <div className="account-radio-tile-group flex-column mb-3">
                    {
                        socialAccounts.map((account, index) => {
                            return (
                                <div key={index} className={`account-radio-tile px-2 py-0 w-100 ${selectedSocialAccount?.social_account.uuid === account.social_account.uuid ? 'selected' : ''}`} onClick={() => setSelectedSocialAccount(account)}>
                                    <div className="h-100 d-flex flex-row align-items-center gap-2 py-2">
                                        <div className="social-account-profile-avatar">
                                            {
                                                account?.social_account?.profile_picture_url ? (
                                                    <img src={account?.social_account?.profile_picture_url} alt={account?.social_account?.handle} className="social-account-profile-image" referrerPolicy='no-referrer' />
                                                ) : (
                                                    <Avatar name={account?.social_account?.handle} size='2rem' className="social-account-profile-image" />
                                                )
                                            }
                                            <span className='social-account-platform-icon bottom-right' style={{ right: '0%', top: '62%' }}>
                                                {
                                                    account?.social_account?.platform === 'ig' && <img src={InstagramLogo as unknown as string} alt="instagram" className='social-account-platform-icon-image' style={{ height: '0.75rem' }} />
                                                }
                                                {
                                                    account?.social_account?.platform === 'yt' && <img src={YoutubeLogo as unknown as string} alt="youtube" className='social-account-platform-icon-image' style={{ height: '0.75rem' }} />
                                                }
                                            </span>
                                        </div>
                                        <span className='text-dark fs-16 fw-600'>@{account.social_account.handle}</span>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <button onClick={() => {
                    if (selectedSocialAccount) {
                        onAccountSelection(selectedSocialAccount);
                    }
                }} disabled={!selectedSocialAccount} className="btn btn-primary">CONFIRM</button>
            </div>

        </div>
    )
}

export default withSlideUpModal(CampaignAccountSelectorModal, "Select Account", true)